import { render, staticRenderFns } from "./staff-item.vue?vue&type=template&id=23602896&scoped=true"
import script from "./staff-item.vue?vue&type=script&lang=js"
export * from "./staff-item.vue?vue&type=script&lang=js"
import style0 from "./staff-item.vue?vue&type=style&index=0&id=23602896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23602896",
  null
  
)

export default component.exports